/**
 * Shared types for the sidebar interview selector components.
 * Extracted to avoid circular dependencies.
 */

export interface InterviewCreationFormValues {
    groupId: string;
    baseInterviewId?: string; // used when duplicating a different interview
    baseGroupId?: string; // used when duplicating a different interview
}

// create a unique key for each interview and group
export const concatenate = (groupId: string, interviewId: string) => `${groupId}_${interviewId}`;
